import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M20 5c.626 0 1.186.288 1.552.739l.008.01A1.99 1.99 0 0 1 22 7v10.668a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7c0-.47.163-.904.435-1.245l.013-.017C2.814 5.288 3.374 5 4 5h16zm.666 2.277l-6.467 4.975a3.607 3.607 0 0 1-4.398 0L3.333 7.277v10.39c0 .368.299.666.667.666h16a.667.667 0 0 0 .667-.666l-.001-10.39zm-.959-.944H4.292l6.322 4.862c.769.592 1.822.627 2.625.105l.147-.105 6.321-4.862z' />
  </svg>
);
